const eventsData = {
    'days': [
        {
            'day': '/images/titles/events/25.png',
            'events': [
                {
                    'name': "Event 1",
                    'schedule': 'HH:MM to HH:MM',
                    'location': 'Location'
                }
            ]
        },
        {
            'day': '/images/titles/events/26.png',
            'events': [
                {
                    'name': "Event 2",
                    'schedule': 'HH:MM to HH:MM',
                    'location': 'Location'
                }
            ]
        },
        {
            'day': '/images/titles/events/27.png',
            'events': [
                {
                    'name': "Event 3",
                    'schedule': 'HH:MM to HH:MM',
                    'location': 'Location'
                }
            ]
        }
    ]
}

export default eventsData